<template>

	<div class="w-full -mx-3">

        <div class="flex flex-wrap w-full font-bold bg-gray-300 rounded text-gray-800 shadow-md mb-6 mx-3">
			<div class="w-full py-3 px-4 md:w-auto -mb-3 md:mb-0">
				<router-link tag="button" to="/admin/sales/add" class="bg-green-600 text-white rounded px-2 py-1">
                    Add Sale
                </router-link>
			</div>
            
			<div class="flex-1 text-left py-3 px-4 w-full md:w-auto md:text-right">
				<router-link tag="button" to="/admin/sales/pending" class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0">
					Pending Sales
				</router-link>
				<router-link tag="button" to="/admin/sales/processing" class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0">
					Processing Sales
				</router-link>
				<!-- <router-link tag="button" to="/admin/sales/completed" class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0">
					Completed Sales
				</router-link> -->
                <router-link tag="button" to="/admin/sales/search" class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0">
					Sale Search
				</router-link>
			</div>
		</div>

        <div class="flex-1 text-left py-1 w-full mx-3">
            <div class="md:flex md:items-center mb-6">
                <div class="md:w-1/3">
                    <label class="block text-grey-darkest font-bold md:text-left mb-1 md:mb-0 pr-4" for="inline-full-name">
                        Filter by Network
                    </label>
                </div>
                <div class="md:w-2/3">
                    <label class="dropdown_wrap">
                        <select class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" v-model="filterNetworkIndex">
                            <option :value="null">{{ sales.length }} - All</option>
                            <option v-for="(network, index) in sortNetworksArrayByAmountOfSales" :value="index">{{ network.purchases }} - {{ network.name }}</option>
                        </select>
                    </label>
                </div>
            </div>
        </div>
        
        <Card class="w-full mb-6 mx-3">
            <template v-slot:header>
                <span v-if="filterNetworkIndex !== null">
                    {{ networks[filterNetworkIndex].name }}
                </span>
                <span v-if="filterNetworkIndex == null">
                    All Pending Sales
                </span>

                <span class="absolute top-0 right-0 px-3 py-1 mt-3 mr-3 rounded text-white bg-red-700 cursor-pointer font-normal" v-if="checkedVideos.length > 0" v-on:click="removeSelectedVideos()">
                    Remove selected videos
                </span>
            </template>
            <template v-slot:body>
                <CustomTable>
                   <template v-slot:header v-if="polling == false">
                        <th class="bg-grey-lightest py-4 pl-4 border-b border-grey-light text-center">
                            <input v-model="checkAll" type="checkbox">
                        </th>
                        <th class="py-4 px-4 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Video</th>
                        <th class="py-4 px-4 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Owner</th>
                        <th class="py-4 px-4 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Purchaser</th>
                        <th class="py-4 px-4 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Date</th>
                        <th class="py-4 px-4 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Amount</th>
                        <th class="py-4 px-4 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"></th>
                    </template>
                    <template v-slot:body>
                        <tr v-for="sale in filteredPendingSalesList">
                            <td class="py-4 pl-4 border-b border-grey-light text-center">
                                <span class="w-2 h-2 rounded-full bg-blue-700 inline-block cursor-pointer" v-if="sale.method == 'cdn'" title="CDN" v-tippy></span>
                                <span class="w-2 h-2 rounded-full bg-green-700 inline-block cursor-pointer" v-if="sale.method == 'email'" title="Email" v-tippy></span>
                                <span class="w-2 h-2 rounded-full bg-black inline-block cursor-pointer" v-if="sale.method == 'manual'" title="Manual" v-tippy></span>
                                <input :checked="checkedVideos.includes(sale.id)" @change="onChange('checkedBox', sale.id, $event)" type="checkbox">
                            </td>
                            <td class="py-4 px-4 border-b border-grey-light">{{ sale.video.title }}</td>
                            <td class="py-4 px-4 border-b border-grey-light">{{ sale.owner.name }}</td>
                            <td class="py-4 px-4 border-b border-grey-light" v-if="filterNetworkIndex !== null">{{ sale.purchaser.name }}</td>
                            <td class="py-4 px-4 border-b border-grey-light" v-if="filterNetworkIndex == null">{{ sale.purchaser.name }} ({{ sale.network.name }})</td>
                            <td class="py-4 px-4 border-b border-grey-light">{{ sale.created_at | displayLocalDateTime }}</td>
                            <td class="py-4 px-4 border-b border-grey-light">${{ sale.price }}</td>
                            <td class="py-4 px-4 border-b border-grey-light text-right">
                                <button class="bg-blue-700 px-2 py-1 text-white text-sm rounded ml-2" v-on:click="viewApproveSaleModal(sale)">
                                    View
                                </button>
                            </td>
                        </tr>
                        <tr class="text-center" v-if="(sales.length == 0) && polling == false">
                            <td colspan="7" class="text-center">There are no sales for this network currently.</td>
                        </tr>
                        <tr class="bg-grey-lighter text-center" v-if="polling">
                            <td class="py-5" colspan="7">
                                <h1 class="text-xl"><i class="fa fa-circle-notch fa-spin"></i></h1>
                            </td>
                        </tr>
                    </template>
                </CustomTable>
            </template>
        </Card>

        <approve-sale-modal></approve-sale-modal>

    </div>
			
</template>

<script>

    import { EventBus } from '@/utils/events';
    import * as Config from '@/config'
    import { mapState, mapGetters } from 'vuex';
    import moment from 'moment';
    import ApproveSaleModal from '../../modals/ApproveSaleModal'

    import CustomTable from '@/components/general/CustomTable'
    import Card from '@/components/partials/Card'
    
    Array.prototype.remByVal = function(val) {
        for (var i = 0; i < this.length; i++) {
            if (this[i] === val) {
                this.splice(i, 1);
                i--;
            }
        }
        return this;
    }

	export default {
		name: 'PendingSales',
		data () {
			return {
                networks: [],
                activeIndex: 0,
                polling: true,
                filterNetworkIndex: null,
                filterNetworkId: null,
                sales: [],

                checkAll: false,
                checkedVideos: [],
			}
        },
        components: {
            'approve-sale-modal': ApproveSaleModal,
            CustomTable,
            Card
		},
        mounted() {
            this.getPendingSales()

            this.$nextTick(function () {
                EventBus.$on('admin-approve-sale-refresh-data', this.getPendingSales);
            }.bind(this));
        },
        watch: {
            filterNetworkIndex: function(index) {
                if(index == null) {
                    this.filterNetworkId = null
                }
                if(index !== null) {
                    this.filterNetworkId = this.networks[index].id
                }
                this.checkedVideos = []
                this.checkAll = false
            },
            checkAll: function(value) {
                var _this = this
                if(value == true) {
                    this.filteredPendingSalesList.forEach(function(el) {
                        _this.checkedVideos.push(el.id)
                    })
                } else {
                    this.filteredPendingSalesList.forEach(function(el) {
                        _this.checkedVideos.remByVal(el.id)
                    })
                }
            }
        },
        computed: {
            filteredPendingSalesList() {
                if(this.filterNetworkId !== null) {
                    var filterNetworkId = this.filterNetworkId
                    return this.sales.filter(function (item) {
                        return item.network_id == filterNetworkId
                    })
                }
                return this.sales
            },
            sortNetworksArrayByAmountOfSales() {
                return this.networks.sort((a, b) => {
                    return b.purchases - a.purchases
                });
            }
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            getPendingSales() {
                var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/admin/sales/latest?status=pending", this.getAuthorizationHeader()).then((response) => {
                    this.$set(this, 'networks', response.data.networks)
                    this.$set(this, 'sales', response.data.sales)
                    this.$set(this, 'polling', false)
                });
            },
            viewApproveSaleModal(data) {
                EventBus.$emit('admin-approve-sale-open-modal', data);
            },
            onChange(value, saleId, $event) {
                const checked = $event.target.checked
                if(checked) {
                    this.checkedVideos.push(saleId)
                    return
                }
                this.checkedVideos.remByVal(saleId)
            },
            removeSelectedVideos() {
                this.$swal({
                    title: "Verify",
                    text: "Are you sure you want to remove " + this.checkedVideos.length + " sale(s)?",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete them.'
                })
                .then((result) => {
                    if (result.value) {
                        var _this = this
                        this.$http.post(Config.apiPath + "/api/v2/admin/sales/delete/bulk", {
                            idsToRemove: _this.checkedVideos
                        }, this.getAuthorizationHeader()).then((response) => {
                            _this.$swal(
                                'Deleted!',
                                'The selected sales have been removed from the system!',
                                'success'
                            )
                            _this.getPendingSales()
                        });
                    }
                });
            }
        },
        filters: {
            displayMethod: function(data) {
                if(data == 'email') {
                    return "Email"
                } else if(data == 'cdn') {
                    return "CDN"
                } else if(data == 'manual') {
                    return "Manual"
                }
            },
            displayLocalDateTime: function(data) {
                return moment.utc(data).local().format('MM/DD/YY h:mm a');
            }
        },
	}
</script>

<style scoped>

</style>
